import { render, staticRenderFns } from "./redHousekeeper.vue?vue&type=template&id=6291e6e2&scoped=true"
import script from "./redHousekeeper.vue?vue&type=script&lang=js"
export * from "./redHousekeeper.vue?vue&type=script&lang=js"
import style0 from "./redHousekeeper.vue?vue&type=style&index=0&id=6291e6e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291e6e2",
  null
  
)

export default component.exports